module.exports = __webpack_public_path__ + "img/pig3.2017f0d4.png";